import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTrendDown, faArrowTrendUp, faArrowsLeftRight, faTicket } from "@fortawesome/free-solid-svg-icons";

const TotalTicketsSold = ({sold}) => {


  var colors = ['#a7a8a0', '#a7a8a0'] 

  const difference = sold.totalTicketsSoldToday - sold.totalTicketsSoldYesterday;

  let data;
  if (difference < 0) {
    data = [
      { id: 'Yesterday', value: sold.totalTicketsSoldYesterday - sold.totalTicketsSoldToday },
      { id: 'Today', value: sold.totalTicketsSoldToday },
    ];
  } else {
    data = [
      { id: 'Yesterday', value: sold.totalTicketsSoldToday -sold.totalTicketsSoldYesterday   },
      { id: 'Today', value: sold.totalTicketsSoldYesterday },
    ];
  }


  if(sold.ticketsSoldPercentage >= 100) {
    data = [
      { id: 'Yesterday', value: 100 },
      { id: 'Today', value: 0 },
    ];
  }

  if (difference === 0) {
    data = [
      { id: 'Yesterday', value: 100 },
      { id: 'Today', value: 0 },
    ];
  } 

  


  return (
    <div style={{display:"flex", justifyContent:"space-around"}}>
         <div style={{width:"30%",marginTop:"1em"}}>
         <FontAwesomeIcon style={{width:"20%"}}  icon={faTicket} />
            <h3>{sold.totalTicketsPurchased}</h3>
            <h5>All Time Tickets Purchased</h5>
            </div>
         
         <div>
            
         </div>
         {/* <div style={{ height: '10vh' , width:"30%",marginTop:"1em"}}>
         <ResponsivePie
        data={data}
        margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
        innerRadius={0.75}
        activeOuterRadiusOffset={8}
        colors={colors}
        borderColor={{
          from: 'color',
          modifiers: [['darker', '0.5']],
        }}
        enableArcLinkLabels={false}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: 'color' }}
        enableArcLabels={false}
        arcLabelsTextColor={{
          from: 'color',
          modifiers: [['darker', '1']],
        }}
        isInteractive={false}
        fill={[
          {
            match: { id: 'Yesterday' },
            id: 'dots',
          },
          {
            match: { id: 'Today' },
            id: 'lines',
          },
        ]}
      />
       <h5>{sold.ticketsSoldPercentage}%</h5>
       <h3 className='pieValue' style={{ position: "absolute", top: "18.6%", left: "50.5%", transform: "translate(-50%, -50%)", zIndex: 1 }}>{sold.ticketsSoldPercentage > 0 ? <FontAwesomeIcon icon={faArrowTrendUp} style={{color: "#26c030",}} /> : <FontAwesomeIcon icon={faArrowTrendDown} style={{color: "#dd2754",}} /> } </h3>
         </div> */}


<div style={{ height: "10vh", width: "30%", marginTop: "1em" }}>
        <div class="pie-chart" style={{backgroundColor:"#61cdbb"}}>
          <div class="inner-circle">
            {sold.ticketsSoldPercentage > 0 ? (
              <FontAwesomeIcon
                icon={faArrowTrendUp}
                style={{ color: "#26c030" }}
              />
            ) : (
              <FontAwesomeIcon icon={faArrowsLeftRight} size='lg' style={{color: "#f4da2f",}} />
            )}
          </div>
        </div>
        <h5 className="percentage">{sold.ticketsSoldPercentage > 0 ? sold.ticketsSoldPercentage + "%" : ''}</h5>
      </div>
     
    </div>
     
  );
};

export default TotalTicketsSold;
